import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faLightbulb, faTag } from '@fortawesome/free-solid-svg-icons';
import HTMLContent from '../HTMLContent';

const FlashcardDisplay = ({ card, theme }) => {
  const [showAnswer, setShowAnswer] = useState(false);

  const styles = {
    container: {
      marginBottom: '1rem',
      marginTop: '2rem',
      width: '100%',
      maxWidth: '1200px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    card: {
      borderRadius: '1rem',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      padding: '0',
      minHeight: '400px',
    },
    questionSection: {
      padding: '2rem',
      background: theme?.primary?.gray?.[50] || '#f5f5f5',
    },
    questionText: {
      fontSize: '1.125rem',
      lineHeight: '1.75',
      color: theme?.primary?.gray?.[900] || '#000000',
      textAlign: 'center',
      fontWeight: 'bold',
    },
    divider: {
      width: '100%',
      height: '1px',
      background: theme?.primary?.gray?.[200] || '#e0e0e0',
    },
    answerSection: {
      padding: '2rem',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: theme?.primary?.gray?.[50] || '#ffffff',
    },
    answerText: {
      fontSize: '1.125rem',
      lineHeight: '1.75',
      color: theme?.primary?.gray?.[900] || '#000000',
      textAlign: 'center',
      fontWeight: '400',
    },
    showAnswerButton: {
      marginTop: '2rem',
      padding: '0.75rem 2rem',
      borderRadius: '0.5rem',
      background: theme?.primary?.blue?.[100] || '#fef3c7',
      border: `1px solid ${theme?.primary?.blue?.[300] || '#fcd34d'}`,
      color: theme?.primary?.blue?.[700] || '#b45309',
      fontSize: '1rem',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    domainButton: {
      marginTop: '2rem',
      padding: '0.75rem 1.5rem',
      borderRadius: '0.5rem',
      background: theme?.primary?.gray?.[100] || '#e5e5e5',
      border: 'none',
      color: theme?.primary?.gray?.[900] || '#000000',
      fontSize: '1rem',
      fontWeight: '400',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      transition: 'all 0.3s ease',
    },
    domainIcon: {
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      background: theme?.primary?.gray?.[600] || '#6b6b6b',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme?.primary?.gray?.[50] || '#ffffff',
      fontSize: '0.75rem',
    },
  };

  return (
    <div style={styles.container}>
      <style>
        {`
          .question-text-content * {
            font-weight: bold !important;
          }
        `}
      </style>
      <div style={styles.card}>
        <div style={styles.questionSection}>
          <div style={styles.questionText} className="question-text-content">
            <HTMLContent 
              htmlContent={card.title} 
              style={{ fontWeight: 'bold' }}
              className="font-bold"
            />
          </div>
        </div>
        {showAnswer ? (
          <>
            <div style={styles.divider} />
            <div style={styles.answerSection}>
              <div style={styles.answerText}>
                <HTMLContent htmlContent={card.description} />
              </div>
              {card.domain_name && (
                <button style={styles.domainButton}>
                  <div style={styles.domainIcon}>
                    <FontAwesomeIcon icon={faTag} />
                  </div>
                  {card.domain_name}
                </button>
              )}
            </div>
          </>
        ) : (
          <div style={styles.answerSection}>
            <button style={styles.showAnswerButton} onClick={() => setShowAnswer(true)}>
              <FontAwesomeIcon icon={faLightbulb} /> Show Answer
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FlashcardDisplay;